import type { OrderCounts } from "@/lib/procurement";

export function DifferencesTile({ counts, loading, active, onClick }: { counts?: OrderCounts["razlike"]; loading: boolean; active: boolean; onClick: () => void }) {
  return <button type="button" className="order-state-tile order-tone-vraceno" aria-pressed={active} onClick={onClick}>
    <span className="font-semibold">Razlike za riješiti</span><span className="text-3xl font-bold">{loading ? "—" : counts?.broj ?? "—"}</span>
    {!loading && counts && <span className="text-sm">{counts.kasni > 0 && <strong className="text-red-800">{counts.kasni} kasni · </strong>}{counts.na_meni} na tebi</span>}
  </button>;
}
